"use client";

import { PolicyToc } from "./policy-toc";

interface TocItem {
  id: string;
  title: string;
}

export function PolicyTocClient({ items }: { items: TocItem[] }) {
  return <PolicyToc items={items} />;
}
